import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

interface Props {
  idBandeira365?: string;
  espelhoVendas?: boolean;
}

export function useListarEmpreendimentos2Filter(props: Props) {
  const fetchData = async () => {
    const hasIdBandeira365 = props.idBandeira365
      ? `&idBandeira365=${props.idBandeira365}`
      : "";
    const hasEspelhoVendas = props.espelhoVendas
      ? `&espelhoVendas=${props.espelhoVendas}`
      : "";
    const LISTAR_EMPREENDIMENTOS2 = `locais/app-web/empreendimentos2/v1?${hasIdBandeira365}${hasEspelhoVendas}`;
    const response = await instance.get(LISTAR_EMPREENDIMENTOS2);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_empreendimentos2"],
    refetchOnMount: false,
  });
  return query;
}
